<template>
	<div id="wrapper" class="container">
	    <div id="step2">
	        <ul class="wx-list ">
	            <li id="area_selector" >
	                <label>国家/地区</label>
	                <input id="area" value="中国大陆" readonly>
	                <!-- <input name="area" type="hidden"> -->
	            </li>
	            <li>
	                <label>手机号</label>
	                <input name="tel" type="tel" placeholder="请输入新手机号" v-model="phone">
	            </li>
	        </ul>
	        <span id="btn_confirm" class="btn btn-gray btn-l" @click="modify()">下一步</span>
	    </div>
	
	</div>
</template>

<script>
	export default{
		data(){
			return{
				telReg : /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/,
				numsStr:"再次获取(60秒)",
				phone:"",
				nums:60,
				clock:'',
				isClick:false,
				phone:'',
				code:'',
			}
		},
		methods:{
			modify:function(){
				var _this = this;

				if(this.phone == ""){
					return weui.alert("手机号不能为空");
				}
				if (!this.telReg.test(this.phone)) {
					return weui.alert("手机号格式错误");
				}
				_this.$axios.post(_this.stuApiUrl + "/student/is-exist", _this.$qs.stringify({phone:_this.phone, isUpdate : 1})).then(function (response) {
					if(!response.data.success){
						return weui.alert(response.data.info);
					}
					_this.$router.replace('/student/user/validate-new-phone/' + _this.phone);
				}).catch(function (error) {
					console.log(error);
				});

                /*if(this.isClick){
                	return;
				}
				
                this.isClick = true;
                _this.$axios.post(_this.stuApiUrl + "/student/modify-phone",
                _this.$qs.stringify({code:_this.code,phone:_this.phone}))
                .then(function (response) {
                	 _this.isClick = false;
                	if(response.data.success){
						weui.alert("修改成功");
						_this.$router.push('/student/user/phone-succeed');
					}else{
						weui.alert(response.data.info);
					}
                }).catch(function (error) {
                	 this.isClick = false;
                    console.log(error);
                });*/
            },
		},
		mounted(){
			this.code = this.$route.params.code;
		},
		beforeDestroy(){
		},
		destroyed(){
		}
	}
</script>

<style scoped>
.code-box{
    line-height: 1.18rem;
    padding: 0 .34rem;
    background-color: #fff;
    border-top: 01px solid #EDEEF2;
    border-bottom: 01px solid #EDEEF2;
    box-sizing: border-box;
    font-size: .3rem;
    margin-bottom: 1.28rem;
}
.code-box label{
    display: inline-block;
    width: 1.1rem;
    text-align: left;
}
.code-box input{
    text-align: left;
    border: 0;
    width: 2rem;
    font-size: .3rem;
}
.code-box .btn-code{
    text-align: center;
    height: .8rem;
    border-left: 01px solid #EDEEF2;
    margin-top: .2rem;
    float: right;
    width: 2.32rem;
    line-height: .8rem;
}

.wx-list li label{
    color: #000;
}
.wx-list li{
    padding-right: .34rem;
}
.wx-list li.wx-link{
    padding-right: .8rem;
    background-image: url("/images/wxstu/launch@2x.png")no-repeat 6.5rem center/.28rem .14rem;
}

.wx-list li input{
    border: none;
    float: right;
    max-width: 3rem;
    line-height: 1.18rem;
    color: #000;
    text-align: right;
    font-size: .3rem;
}
</style>



// WEBPACK FOOTER //
// src/components/student/user/modify-phone.vue